const MIN = 1;

const initQuantity = () => {
  document.querySelectorAll('[data-quantity]').forEach((block) => {
    const input = block.querySelector('[data-quantity-input]');
    const minus = block.querySelector('[data-quantity-minus]');
    const plus = block.querySelector('[data-quantity-plus]');

    if (!input) {
      return;
    }

    const setValue = (value, emitInput = false) => {
      const next = parseInt(value, 10);
      input.value = isNaN(next) || next < MIN ? MIN : next;

      if (minus) {
        minus.disabled = Number(input.value) <= MIN;
      }

      if (emitInput) {
        input.dispatchEvent(new Event('input', {bubbles: true}));
      }
    };

    if (minus) {
      minus.addEventListener('click', () => {
        setValue(Number(input.value) - 1, true);
      });
    }

    if (plus) {
      plus.addEventListener('click', () => {
        setValue(Number(input.value) + 1, true);
      });
    }

    input.addEventListener('change', () => {
      setValue(input.value);
    });

    setValue(input.value);
  });
};

export {initQuantity};
